import { getProjectIdOrKey } from '@atlassian/jira-router-resources-utils/src/utils/get-project-key-id/index.tsx';
import {
	createResource,
	useResource,
	type RouteResource,
	type UseResourceHookResponse,
} from '@atlassian/react-resource-router';
import { RESOURCE_TYPE_PROJECT_WORKFLOW_CONTEXT } from './constants.tsx';
import type { ProjectWorkflowContext } from './types.tsx';

const getDataLoader = () =>
	import(
		/* webpackChunkName: "async-resource-project-workflow-context", jiraSpaEntry: "async-resource-project-workflow-context" */ './get-data'
	);

export const projectWorkflowContextResource: RouteResource<ProjectWorkflowContext | null> =
	createResource<ProjectWorkflowContext | null>({
		type: RESOURCE_TYPE_PROJECT_WORKFLOW_CONTEXT,
		getKey: (matchedRoute) => getProjectIdOrKey(matchedRoute.match, matchedRoute.query),
		getDataLoader,
		maxAge: 0,
		isCritical: true,
		isBrowserOnly: true,
	});

export const useWorkflowProjectContext =
	(): UseResourceHookResponse<ProjectWorkflowContext | null> =>
		useResource<ProjectWorkflowContext | null>(projectWorkflowContextResource);
